import { SetStateAction, Dispatch, useRef, useState } from "react";
import useStyles, { Card } from "../../styles";
import Grid from "@material-ui/core/Grid";
import { clsx } from 'modules/Utils';
import CircularStep from "../CircularStep";
import { VideoAdsRecord, YouTubeCampaignData } from "modules/Types";
import { useHistory } from "react-router-dom";
import { formatCountries } from "../../../utils";
import useScreen from "Hooks/useScreen";
import useBrand from 'Hooks/useBrand';
import { DEFAULT_CURRENCY, PlaybookType } from "modules/Const";
import { StyledLabelP } from "modules/Sty";
import SubmitOrCheckoutButtonsView from "components/CampaignViews/SubmitOrCheckoutButtonsView";
import useCampaignBuilder from "Hooks/useCampaignBuilder";

interface Props {
  campaignId: string | null
  record: VideoAdsRecord | null;
  targeting: VideoAdsRecord[];
  selectedCountries: { label: string; value: string }[];
  targetingType: string;
  geographyType: string;
  setCreatingCampaign: Dispatch<SetStateAction<boolean>>;
  cancelSaving: () => void;
  confirmed: boolean;
  refundFeeConfirmed: boolean;
}

const GoLiveCard = ({
  campaignId,
  record,
  targeting,
  targetingType,
  geographyType,
  selectedCountries,
  confirmed,
  refundFeeConfirmed
}: Props) => {

  const classes = useStyles();
  const { mobileView } = useScreen()
  const { budget, startDate, endDate } = useCampaignBuilder();

  const overrideCampaignInput: YouTubeCampaignData = {
    budget: Number(budget),
    id: campaignId ? parseInt(campaignId) : undefined,
    campaign_type: "increase_video_views",
    playbookType: PlaybookType.INCREASE_VIDEO_VIEWS,
    price_data: {
      price: Number(budget),
      name: `YouTube Ads Campaign for "${record?.name}"`,
      description: `"${record?.name}" (Increase Video Views Campaign)`,
    },
    logistics: {
      refundFeeConfirmed,
      confirmedCampaignSettings: confirmed,
      budget: Number(budget),
      startDate: startDate || '',
      endDate: endDate || '',
    },
    content: {
      name: record?.name,
      id: record?.id,
      thumbnail_url: record?.primaryThumbnail,
      channelId: record?.channelId,
      channelTitle: record?.channelTitle,
    },
    targeting,
    targetingType,
    geographies: {
      type: geographyType,
      countries: formatCountries(geographyType, selectedCountries) || [],
    },
    campaign_platforms: ["youtube"],
    payment_method: "stripe",
  }

  return (
    <Card borderRadius={mobileView ? undefined : "12px"}>
      <Grid container direction="column">
        <Grid item className={clsx(classes.space, classes.border)}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <CircularStep step="⚡" />
            </Grid>
            <StyledLabelP fontSize={18} fontWeight={600}>
              Let's go live
            </StyledLabelP>
          </Grid>
        </Grid>

        <div>
          <SubmitOrCheckoutButtonsView overrideCampaignInput={overrideCampaignInput} style={{
            padding: 24
          }} />
        </div>
      </Grid>
    </Card>
  );
};

export default GoLiveCard;
